import { render, staticRenderFns } from "./MainCoverMobile.vue?vue&type=template&id=f46e87a6&scoped=true&"
import script from "./MainCoverMobile.vue?vue&type=script&lang=js&"
export * from "./MainCoverMobile.vue?vue&type=script&lang=js&"
import style0 from "./MainCoverMobile.vue?vue&type=style&index=0&id=f46e87a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46e87a6",
  null
  
)

export default component.exports